<div class="close" (click)="close()">{{ 'NGX-MESSAGING.close' | translate }}</div>
<h1 mat-dialog-title class="mat-dialog-container__title">
  {{ 'NGX-MESSAGING.conversation_name' | translate | uppercase }}
</h1>
<div mat-dialog-content>
  <form [formGroup]="newChatForm">
    <mat-form-field appearance="fill" class="full-width-input">
      <input matInput placeholder="{{ 'NGX-MESSAGING.displayName' | translate }}" formControlName="displayName" />
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button class="chat-input__button" color="primary" (click)="save()" [disabled]="!newChatForm.valid">
    {{ 'NGX-MESSAGING.save' | translate }}
  </button>
</div>
